import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import Pc1 from './images/Pc1.jpg'
import Pc from './images/Pc.jpg'
// import Pagination from './Pagination';
import Pc2 from './images/BnB.jpg'
import PVB from './images/PVB.jpg'
import Pc3 from './images/PB.jpg'
import Sun from './images/Sun.jpg'
import Stu from './images/Stu.jpg'
import Pc6 from './images/Pc6.jpg'
import Pc8 from './images/Pc8.jpg'
import PQu from './images/PQu.jpg'
import Pc7 from './images/Pc7.jpg'
import ForeB from './images/ForeB.jpg'
import ForSm from './images/ForSm.jpg'
import './carosel.css'
import { Zoom } from 'react-reveal';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = {
root: {
position: 'relative',
},
slide: {

minHeight: 200,
color: '#fff',
},
slide1: {
// backgroundColor: '#FEA900',
},
slide2: {
// backgroundColor: '#B3DC4A',
},
slide3: {
// backgroundColor: '#6AC0FF',
},
slide1: {
// backgroundColor: '#FEA900',
},
slide2: {
// backgroundColor: '#B3DC4A',
},
slide3: {
// backgroundColor: '#6AC0FF',
},
slide1: {
// backgroundColor: '#FEA900',
},
slide2: {
// backgroundColor: '#B3DC4A',
},
slide3: {
// backgroundColor: '#6AC0FF',
},
};

class DemoAutoPlay extends React.Component {
state = {
index: 0,
};

handleChangeIndex = index => {
this.setState({
index,
});
};

render() {
const { index } = this.state;

return (
        <div className="
        ">
          <div style={styles.root}>
            <Zoom top>
             <AutoPlaySwipeableViews index={index} onChangeIndex={this.handleChangeIndex}>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide2)}><img src={Pc}></img></div>            
                <div className="img" style={Object.assign({}, styles.slide, styles.slide1)}><img src={Pc2}/></div>
                <div className="img" style={Object.assign({}, styles.slide, styles.slide1)}><img src={ForSm}/></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide2)}><img src={Pc7}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide2)}><img src={PVB}></img></div>  
                <div  className="img"  style={Object.assign({}, styles.slide, styles.slide3)}><img src={Pc8}></img></div>
                <div  className="img"  style={Object.assign({}, styles.slide, styles.slide3)}><img src={ForeB}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide1)}><img src={Stu}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide2)}><img src={Pc6}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide3)}><img src={PQu}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide1)}><img src={Pc3}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide2)}><img src={Sun}></img></div>
                <div  className="img" style={Object.assign({}, styles.slide, styles.slide3)}><img src={Pc1}></img></div>
            </AutoPlaySwipeableViews>
        </Zoom>
        {/* <Pagination dots={9} index={index} onChangeIndex={this.handleChangeIndex} /> */}
       </div>
    </div>
        );
}
}

export default DemoAutoPlay;